import { useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

const statusStyles = {
  present: 'bg-emerald-50 text-emerald-900 border-emerald-300',
  late: 'bg-yellow-50 text-yellow-900 border-yellow-400',
  half_day: 'bg-orange-50 text-orange-900 border-orange-300',
  absent: 'bg-red-50 text-red-900 border-red-300',
};

export const MobileAttendanceCalendar = ({ employees, records, month, empMap, today, currentUserId }) => {
  const [employeeId, setEmployeeId] = useState(currentUserId);
  const [selectedDay, setSelectedDay] = useState(today.startsWith(month) ? today : `${month}-01`);
  const employee = employees.find(emp => emp.id === employeeId) || employees[0];
  const [year, mon] = month.split('-').map(Number);
  const dayCount = new Date(year, mon, 0).getDate();
  const offset = new Date(year, mon - 1, 1).getDay();
  const dayStatus = date => empMap[employee?.id]?.[date] || (date < today ? 'absent' : null);
  const date = selectedDay.startsWith(month) ? selectedDay : `${month}-01`;
  const sessions = records.filter(r => r.employee_id === employee?.id && r.date === date);
  const status = dayStatus(date);
  return <div className="mobile-attendance-view space-y-4" data-testid="mobile-attendance-calendar">
    {employees.length > 1 && <Select value={employee?.id} onValueChange={setEmployeeId}>
      <SelectTrigger aria-label="Calendar employee" data-testid="mobile-calendar-employee"><SelectValue /></SelectTrigger>
      <SelectContent>{employees.map(emp => <SelectItem key={emp.id} value={emp.id}
        data-testid={`mobile-calendar-employee-${emp.id}`}>{emp.name}</SelectItem>)}</SelectContent>
    </Select>}
    <div className="grid grid-cols-7 gap-1" data-testid="mobile-calendar-days">
      {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => <span key={day} className="text-center text-[11px] text-neutral-600 py-1">{day}</span>)}
      {Array.from({ length: offset }, (_, index) => <span key={`space-${index}`} aria-hidden="true" />)}
      {Array.from({ length: dayCount }, (_, index) => {
        const day = `${month}-${String(index + 1).padStart(2, '0')}`;
        const state = dayStatus(day);
        return <button key={day} onClick={() => setSelectedDay(day)} aria-pressed={date === day}
          aria-label={`${day}: ${(state || (day > today ? 'Upcoming' : 'Not marked')).replace('_', ' ')}`}
          data-testid={`mobile-calendar-day-${day}`}
          className={`calendar-day min-w-0 min-h-11 rounded border text-sm font-medium transition-colors ${statusStyles[state] || (state ? statusStyles.absent : 'border-neutral-200 bg-white text-neutral-700')} ${date === day ? 'ring-2 ring-neutral-800 ring-offset-1' : ''} ${day === today ? 'font-bold underline underline-offset-4' : ''}`}>
          {index + 1}
        </button>;
      })}
    </div>
    <div className="border-t border-neutral-200 pt-4 space-y-2" aria-live="polite" data-testid="mobile-calendar-detail">
      <p className="text-sm font-semibold" data-testid="mobile-calendar-selected-date">{date} · {employee?.name}</p>
      <p className="text-sm capitalize" data-testid="mobile-calendar-selected-status">{(status || (date > today ? 'Upcoming' : 'Not marked')).replace('_', ' ')}</p>
      {sessions.map(record => <div key={record.id} className="flex flex-wrap justify-between gap-2 text-sm" data-testid={`mobile-calendar-session-${record.id}`}>
        <span>In: <strong>{record.in_time || '—'}</strong></span>
        <span>Out: <strong>{record.out_time || '—'}</strong></span>
        {record.half_day_session && <span className="w-full capitalize text-xs text-neutral-600">{record.half_day_session}</span>}
      </div>)}
    </div>
  </div>;
};